"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIntent = exports.parseEntity = exports.parseTentativeEntities = exports.parseTranscript = exports.parseTentativeTranscript = void 0;
function parseTentativeTranscript(data) {
    return data.words.map(({ word, index, start_timestamp, end_timestamp }) => {
        return {
            value: word,
            index: index,
            startTimestamp: start_timestamp,
            endTimestamp: end_timestamp,
            isFinal: false,
        };
    });
}
exports.parseTentativeTranscript = parseTentativeTranscript;
function parseTranscript(data) {
    return {
        value: data.word,
        index: data.index,
        startTimestamp: data.start_timestamp,
        endTimestamp: data.end_timestamp,
        isFinal: true,
    };
}
exports.parseTranscript = parseTranscript;
function parseTentativeEntities(data) {
    return data.entities.map(({ entity, value, start_position, end_position }) => {
        return {
            type: entity,
            value: value,
            startPosition: start_position,
            endPosition: end_position,
            isFinal: false,
        };
    });
}
exports.parseTentativeEntities = parseTentativeEntities;
function parseEntity(data) {
    return {
        type: data.entity,
        value: data.value,
        startPosition: data.start_position,
        endPosition: data.end_position,
        isFinal: true,
    };
}
exports.parseEntity = parseEntity;
function parseIntent(data, isFinal) {
    return {
        intent: data.intent,
        isFinal: isFinal,
    };
}
exports.parseIntent = parseIntent;
